function moveNav(nav) {
    var blob = $('.blob')
    var navElement = $('#' + nav + "Nav")
  
    var blobNav = $(navElement)
    var offset = blobNav.offset();
    var posY = offset.top - (blob.height() / 3);
  
    return posY;
  };

export {moveNav};